declare global {
    interface Window {
        eshopWidgets: any,
        eShopWidgets: Array<string>;
    }
}

export function getWidget(name: string) {
    if (window.eshopWidgets) {
        if (window.eshopWidgets[name]) {
            return window.eshopWidgets[name];
        }
    }

    return null;
}

export function getWidgetNeed(name: string) {

    if (window.eShopWidgets) {
        for(let i= 0 ;i< window.eShopWidgets.length;i++ ){
            if(name === window.eShopWidgets[i] ){
                return true;
            }
        }
        return false;
    } else { return getWidget(name); }

}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/get-widget.ts